import {
    IconButton,
    Popover,
    popoverClasses,
    PopoverOrigin,
    Stack,
    Typography,
} from '@mui/material'
import { FC, PropsWithChildren, ReactNode } from 'react'
import CloseIcon from '../../../../assets/icons/Close.svg?react'

type Props = {
    anchorEl: HTMLElement | null
    onClose?: VoidFunction
    title: string
    footer?: ReactNode
    anchorOrigin?: PopoverOrigin
    transformOrigin?: PopoverOrigin
}

export const InfoPopover: FC<PropsWithChildren<Props>> = ({
    anchorEl,
    onClose,
    title,
    footer,
    children,
    anchorOrigin,
    transformOrigin,
}) => {
    const open = Boolean(anchorEl)

    return (
        <Popover
            aria-hidden="true"
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            anchorOrigin={anchorOrigin}
            transformOrigin={transformOrigin}
            disableEnforceFocus
            disableAutoFocus
            sx={{
                [`.${popoverClasses.paper}`]: {
                    width: 346,
                    borderRadius: '12px',
                    border: '1px solid #E9EAED',
                    boxShadow: 'none',
                    overflow: 'hidden',
                },
            }}>
            <Stack direction="column" p={2} gap={1}>
                <Stack direction="row" justifyContent="space-between">
                    <Typography
                        variant="h5"
                        color="#181B25"
                        sx={{
                            width: '100%',
                            display: '-webkit-box',
                            WebkitLineClamp: '3',
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                        }}>
                        {title}
                    </Typography>
                    <IconButton
                        onClick={onClose}
                        sx={{
                            width: '24px',
                            height: '24px',
                            p: 0,
                        }}>
                        <CloseIcon color="#121317" />
                    </IconButton>
                </Stack>
                <Stack>{children}</Stack>
            </Stack>
            {footer && (
                <Stack
                    direction="row"
                    alignItems="center"
                    gap={1}
                    p={1}
                    sx={{
                        borderTop: '1px solid #E5E5E7',
                    }}>
                    {footer}
                </Stack>
            )}
        </Popover>
    )
}
